import React from "react";
import MainTemplate from "../../components/MainTemplate/MainTemplate";
import CardBackground from "../../components/MainTemplate/CardBackground";
import BackupRestoreChild from "./BackupRestoreChild";

const BackupRestore = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <BackupRestoreChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default BackupRestore;
